/** Payment scenarion condition comparison types */
export enum PaymentScenarionConditionTypeEnum {
  /** Value is equal (`=`) */
  EQUAL = 'EQUAL',
  /** Value is bigger than (`>`) */
  BIGGER_THAN = 'BIGGER_THAN',
  /** Value is lower than (`<`) */
  LOWER_THAN = 'LOWER_THAN',
  /** Value without a sign */
  NONE = 'NONE',
}
